import type { NamePool } from "@/core/types.js";

export const jpNamePool: NamePool = {
  given: {
    male: ["Hiroshi","Kenji","Takashi","Masaki","Yusuke","Daisuke","Shota","Kazuki","Ryota","Naoki","Taro","Jiro","Akira","Satoshi","Tetsuya","Makoto","Shinji","Koji","Noboru","Hideo"],
    female: ["Yuki","Haruka","Sakura","Aoi","Misaki","Rina","Nana","Mika","Yuko","Ayaka","Hanako","Kimiko","Noriko","Keiko","Fumiko","Michiko","Sumiko","Yoshiko","Tomoko","Naoko"],
  },
  family: ["Tanaka","Suzuki","Sato","Watanabe","Ito","Nakamura","Kobayashi","Kato","Yamamoto","Hayashi","Inoue","Kimura","Matsumoto","Fujiwara","Ogawa","Nishimura","Mori","Abe","Ikeda","Hashimoto","Yamada","Ishikawa","Maeda","Fujita","Goto"],
};
